import { render, staticRenderFns } from "./pinWorks.vue?vue&type=template&id=68de0cab&scoped=true&"
import script from "./pinWorks.vue?vue&type=script&lang=js&"
export * from "./pinWorks.vue?vue&type=script&lang=js&"
import style0 from "./pinWorks.vue?vue&type=style&index=0&id=68de0cab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68de0cab",
  null
  
)

export default component.exports